import React from 'react';

import { Formik } from 'formik';
import { pick } from 'lodash';
import PropTypes from 'prop-types';

import { PageHeader } from 'modules/common/layouts';
import {
  FormInputTextArea,
  FormInput,
  FormInputMobileNumber,
} from 'modules/common/input';
import { Button } from 'modules/common';
import { AUTH_TYPE } from 'modules/partial/constants';

import { contactUsSchema } from '../validations';
import { usePostContactUs } from '../hooks';
import { useGetMerchantProfile } from '../../merchant/settings/store-profile/hooks';

const INIT_FORM = {
  email_address: '',
  full_name: '',
  mobile_number: '',
  body: '',
};

function ContactUs({ isModal, onClose }) {
  const authType = React.useContext(AUTH_TYPE);
  const [validation, setValidation] = React.useState(false);

  const [isPostLoading, post] = usePostContactUs();
  const [isGetLoading, data] = useGetMerchantProfile();

  const isLoading = isGetLoading || isPostLoading;

  const handleSubmit = (payload, { resetForm }) => {
    const args = {
      payload,
    };

    post(args, () => {
      onClose();
      resetForm();
    });
  };

  return (
    <Formik
      validationSchema={contactUsSchema}
      initialValues={{ ...INIT_FORM, ...pick(data, Object.keys(INIT_FORM)) }}
      enableReinitialize
      onSubmit={handleSubmit}
      validateOnChange={validation}
      validateOnBlur={validation}
    >
      {({ submitForm, resetForm, values, errors, setFieldValue }) => (
        <>
          {!isModal && (
            <PageHeader
              title="Contact Us"
              goBack="/settings"
              withButtonAction={
                <>
                  <Button
                    className="ds-btn"
                    label="Cancel"
                    disabled={isLoading}
                    onClick={() => resetForm()}
                  />
                  <Button
                    className="ds-btn ds-primary"
                    label="Submit"
                    disabled={isLoading}
                    onClick={() => {
                      submitForm();
                      setValidation(true);
                    }}
                  />
                </>
              }
              withTabTitle={authType === 'MERCHANT'}
              withTitleContainer={authType === 'MERCHANT'}
            />
          )}

          <div className="space-y-5">
            <FormInput
              name="full_name"
              label="Full Name"
              error={errors?.full_name}
              value={values?.full_name}
              onSetFieldValue={setFieldValue}
              required
            />
            <FormInput
              name="email_address"
              label="Email Address"
              error={errors?.email_address}
              value={values?.email_address}
              onSetFieldValue={setFieldValue}
              required
            />
            <FormInputMobileNumber
              name="mobile_number"
              label="Phone Number"
              icon={false}
              error={errors?.mobile_number}
              value={values?.mobile_number}
              onSetFieldValue={setFieldValue}
              required
            />
            <FormInputTextArea
              name="body"
              label="Message"
              error={errors?.body}
              value={values?.body}
              onSetFieldValue={setFieldValue}
              required
            />

            {isModal && (
              <div className="flex justify-end gap-3">
                <Button
                  className="ds-btn"
                  label="Cancel"
                  disabled={isLoading}
                  onClick={onClose}
                />
                <Button
                  className="ds-btn ds-primary"
                  label="Submit"
                  disabled={isLoading}
                  isLoading={isLoading}
                  onClick={() => {
                    submitForm();
                    setValidation(true);
                  }}
                  withLoader
                />
              </div>
            )}
          </div>
        </>
      )}
    </Formik>
  );
}

ContactUs.defaultProps = {
  isModal: false,
  onClose: () => {},
};
ContactUs.propTypes = {
  isModal: PropTypes.bool,
  onClose: PropTypes.instanceOf(Function),
};

export default ContactUs;
